import { render, staticRenderFns } from "./documentManagement.vue?vue&type=template&id=067140d2"
import script from "./documentManagement.vue?vue&type=script&lang=js"
export * from "./documentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports